module.exports = __webpack_public_path__ + "img/contact.a145803d.jpg";